import { CreditUsageType } from '../definition';

export const CreditUsageTitle: Record<CreditUsageType, string> = {
  CONTACT_PROFILE_REVEAL: 'Full Profile Enrichment',
  CONTACT_PROFILE_UPDATE: 'Full Profile Update',
  CONTACT_EMAIL_FINDING: 'Valid Email Found',
  CONTACT_EMAIL_REVERIFICATION: 'Email Re-verification',
  CONTACT_PHONE_FINDING: 'Valid Mobile Phone Found',
  CONTACT_STORAGE_BASIC: 'Basic Contact Storage',
  CONTACT_STORAGE_ENRICH: 'Contact Stored Job Change Update',
  CONTACT_STORAGE_AI: 'Lookalike Contact Storage (Coming Soon)',
  ACCOUNT_STORAGE_BASIC: 'Basic Account Storage',
  ACCOUNT_STORAGE_AI: 'Lookalike Account Storage',
  CONTACT_ANALYSIS_REVEAL: 'AI Profile Analysis',
  CONTACT_ANALYSIS_UPDATE: 'AI Profile Analysis Update',
  CONTACT_EMAIL_GUESS_RETRIEVAL: 'Email Guess Retrieval',
  ACCOUNT_STORAGE_ENRICH: 'Account Storage Enrichment',
};

/** Display order for credit usage lists (e.g. pricing “How credits work”). */
export const CREDIT_USAGE_DISPLAY_ORDER: readonly CreditUsageType[] = [
  CreditUsageType.CONTACT_PROFILE_REVEAL,
  CreditUsageType.CONTACT_PROFILE_UPDATE,
  CreditUsageType.CONTACT_EMAIL_FINDING,
  CreditUsageType.CONTACT_EMAIL_REVERIFICATION,
  CreditUsageType.CONTACT_PHONE_FINDING,
  CreditUsageType.CONTACT_STORAGE_BASIC,
  CreditUsageType.CONTACT_STORAGE_ENRICH,
  CreditUsageType.CONTACT_STORAGE_AI,
  CreditUsageType.ACCOUNT_STORAGE_BASIC,
  CreditUsageType.ACCOUNT_STORAGE_AI,
  CreditUsageType.CONTACT_ANALYSIS_REVEAL,
  CreditUsageType.CONTACT_ANALYSIS_UPDATE,
  CreditUsageType.CONTACT_EMAIL_GUESS_RETRIEVAL,
  CreditUsageType.ACCOUNT_STORAGE_ENRICH,
] as const;
